var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMenu = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 204.793h1024v102.404H0z",
  className: "menu_svg__path1"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 460.796h1024V563.2H0z",
  className: "menu_svg__path2"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M0 716.804h1024v102.404H0z",
  className: "menu_svg__path3"
})));
export { SvgMenu as ReactComponent };